import LikeHeartIcon from '../src/LikeHeartIcon';
export default LikeHeartIcon;
